import { useGetMyWhatsAppNumbers } from 'shared/hooks/useGetMyWhatsAppNumbers'

import { Features } from './useHasClientFeature'
import { useHasFeature } from './useHasFeature'

/**
 * Check a message can be sent via WhatsApp
 * @param toNumbers
 * @param fromNumber
 * @returns boolean
 */
export const useCanSendWhatsApp = () => {
    const isWhatsAppEnabled = useHasFeature(Features.whatsapp)

    const { myWhatsAppNumbers } = useGetMyWhatsAppNumbers()

    return isWhatsAppEnabled && myWhatsAppNumbers.length > 0
}
